import React, { useState, useEffect } from 'react';
import { Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';  
interface Props {
  walletAddress: string;
  purpose: string;
  informationSource: string;
  satisfaction: string;
  feedback: string;
}

const SubmitButton: React.FC<Props> = ({ walletAddress, purpose, informationSource, satisfaction, feedback }) => {
  // フォームが有効かどうかを追跡する状態
  const [isFormValid, setIsFormValid] = useState(false);
  const navigate = useNavigate(); 
  // フォームの有効性をチェックする効果
  useEffect(() => {
    if (purpose && feedback) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [walletAddress, purpose, informationSource, satisfaction, feedback]);


  const handleClick = () => {  // 追加: クリックイベントハンドラー
    // navigate('/3');  // バックアップページへ遷移
  };

  return (
    <div className="questionneirSection">
      <Button
        id="thanksButton"
        type="submit"
        value="送信"
        isDisabled={!isFormValid}
        colorScheme="teal"
        size={{ base: "sm", md: "md" }} // 画面サイズに応じてボタンサイズを変更
        width={{ base: "100%", md: "auto" }} // 画面サイズに応じてボタンの幅を変更
        fontSize={{ base: "xs", sm: "sm", md: "md" }} // 画面サイズに応じてフォントサイズを変更
        onClick={handleClick}
        style={{ marginTop: '20px' }} 
      >
        アンケートを送信してNFTを受け取る
      </Button>
    </div>
  );
};

export default SubmitButton;
